var render = function render(){var _vm=this,_c=_vm._self._c;return _c('yandex-map',{staticStyle:{"width":"100%","height":"400px"},attrs:{"settings":_vm.settings,"coords":[_vm.building.map.latitude, _vm.building.map.longitude],"zoom":15,"controls":[]},on:{"map-was-initialized":_vm.initHandler}},[_c('ymap-marker',{attrs:{"icon":{
                layout: 'default#image',
                imageHref: '/assets/site/images/markers/marker-' + _vm.building.status_color + '.svg',
                imageSize: [20, 20],
                imageOffset: [0, 0],
                },"coords":[_vm.building.map.latitude, _vm.building.map.longitude],"marker-id":_vm.building.id,"marker-type":"placemark"}},[_c('balloon',{attrs:{"slot":"balloon","building":_vm.building},slot:"balloon"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }